import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

interface Props {
  title: string;
  description: string;
  badge?: React.ReactNode;
  icon: React.ReactNode;
  onClick: () => void;
}

export const MFATypeButton = (props: Props) => {
  const { title, description, badge, icon, onClick } = props;

  return (
    <ChakraV3.Button
      size='lg'
      p={0}
      w='full'
      h='full'
      variant='outline'
      rounded='xl'
      onClick={onClick}
      _hover={{ bg: 'gray.50', borderColor: 'gray.500' }}
    >
      <ChakraV3.HStack w='full' gap={4} alignItems='center' py={4} px={4}>
        <ChakraV3.Icon fontSize='20' color='gray.600'>
          {icon}
        </ChakraV3.Icon>
        <ChakraV3.Stack w='full' alignItems='start' gap={0}>
          <ChakraV3.HStack w='full'>
            <ChakraV3.Text fontSize='md' fontWeight='semibold'>
              {title}
            </ChakraV3.Text>
            <ChakraV3.Spacer />
            {badge}
          </ChakraV3.HStack>
          <ChakraV3.Text fontSize='sm' color='secondary' fontWeight='normal'>
            {description}
          </ChakraV3.Text>
        </ChakraV3.Stack>
      </ChakraV3.HStack>
    </ChakraV3.Button>
  );
};
